const realpressContactFormSendEmail = (formNode) => {
    if (!formNode) {
        return;
    }
    const sendMessageNode = formNode.querySelector('button.realpress-send-message');
    const restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';
    sendMessageNode.addEventListener('click', function () {
        sendMessageNode.disabled = true;
        sendMessageNode.insertAdjacentHTML('afterbegin', ' <i class="fa fa-spinner fa-spin"></i>' + ' ');
        const emailTarget = formNode.querySelector('input[name="email-target"]').value || '';
        const name = formNode.querySelector('input[name="name"]').value || '';
        const phone = formNode.querySelector('input[name="phone"]').value || '';
        const email = formNode.querySelector('input[name="email"]').value || '';
        const message = formNode.querySelector(' textarea[name="message"]').value || '';
        let termsAndConditions;
        const termsAndConditionsNode = formNode.querySelector('input[name="terms_and_conditions"]');
        if (termsAndConditionsNode) {
            termsAndConditions = termsAndConditionsNode.checked || false;
        } else {
            termsAndConditions = true;
        }

        const data = {email_target: emailTarget, name, phone, email, message, terms_and_conditions: termsAndConditions};
        const messageResultNode = formNode.querySelector('.realpress-message-result');
        wp.apiFetch({
            path: '/' + restNamespace + '/contact-form',
            method: 'POST',
            data,
        }).then((res) => {
            if (res.msg) {
                messageResultNode.classList.remove('failed');
                messageResultNode.classList.add('success');
                messageResultNode.innerHTML = res.msg;
            }
        }).catch((err) => {
            if (err.msg) {
                messageResultNode.classList.remove('success');
                messageResultNode.classList.add('failed');
                messageResultNode.innerHTML = err.msg;
            }
        }).finally(() => {
            sendMessageNode.disabled = false;
            sendMessageNode.querySelector('i.fa-spinner').remove();
        });
    });
};

export {realpressContactFormSendEmail};
